import { render, staticRenderFns } from "./LockPlus.vue?vue&type=template&id=3c134436"
import script from "./LockPlus.vue?vue&type=script&lang=js"
export * from "./LockPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports